import React, { useId } from 'react';

/**
 * Logo — the OmniPrac mark rendered as INLINE SVG (not an <img>), so the
 * wordmark uses the page's font (Outfit, loaded in public/index.html).
 *
 * Props:
 *   variant  'full' (mark + wordmark) | 'icon' (mark only)   default 'full'
 *   white    true for dark backgrounds (white mark/wordmark) default false
 *   className applied to the <svg> for sizing
 */
const Logo = ({ variant = 'full', white = false, className = '' }) => {
  const gid = useId().replace(/:/g, '');
  const isIcon = variant === 'icon';

  const crossStroke = white ? '#ffffff' : `url(#${gid})`;
  const cutout = white ? '#0C2F52' : '#ffffff';
  const arrow = white ? '#5FE0D3' : '#129995';
  const textFill = white ? '#ffffff' : '#0f385c';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={isIcon ? '0 0 200 200' : '0 0 660 200'}
      className={className}
      role="img"
      aria-label="OmniPrac"
    >
      {!white && (
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#0f385c" />
            <stop offset="1" stopColor="#129995" />
          </linearGradient>
        </defs>
      )}

      <path d="M 100,60 L 100,140 M 60,100 L 140,100" fill="none" stroke={crossStroke} strokeWidth="24" strokeLinecap="round" />
      <path d="M 80,120 Q 120,120 160,45" fill="none" stroke={cutout} strokeWidth="26" strokeLinecap="round" />
      <path d="M 80,120 Q 120,120 160,45" fill="none" stroke={arrow} strokeWidth="12" strokeLinecap="round" />
      <polygon points="145,45 180,30 165,65" fill={arrow} stroke={arrow} strokeWidth="4" strokeLinejoin="round" />

      {!isIcon && (
        <text
          x="205"
          y="132"
          fill={textFill}
          style={{ fontFamily: "'Outfit', 'Poppins', 'Montserrat', sans-serif", fontWeight: 700, fontSize: '90px', letterSpacing: '-2px' }}
        >
          OmniPrac
        </text>
      )}
    </svg>
  );
};

export default Logo;
